import { offerDeleted } from 'services/typewriter';
import { flatten } from 'inc/utils';
import {
  getEntity,
  segmentBrandObject,
  segmentCompanyObject,
  segmentOfferObject,
  segmentContextObject,
} from './helpers';

export default async ({ data: values }: Data) => {
  const offer = flatten(values);
  const brand = await getEntity('brands', offer['brand']);
  const company = await getEntity('companies', brand['company']);
  offerDeleted({
    context: segmentContextObject(company, brand),
    brand: segmentBrandObject(brand, company),
    company: segmentCompanyObject(company),
    offer: segmentOfferObject(offer),
  });
  window.analytics.group(offer['id'], {
    company: segmentCompanyObject(company),
    brand: segmentBrandObject(brand, company),
  });
};
